<template>
    <div
        role="presentation"
        class="c-message__reply_bar c-message_kit__thread_replies"
        data-qa="reply_bar"
        v-if="visible"
        @click="$emit('show_replies')"
    ><span
            class="c-message__reply_bar_avatar c-avatar"
            style="height: 24px; width: 24px;"
        ><img
                src="https://ca.slack-edge.com/T01NZJV2ADU-U02DRRJCURL-g663367a9597-24"
                srcset="https://ca.slack-edge.com/T01NZJV2ADU-U02DRRJCURL-g663367a9597-48 2x"
                class="c-base_icon c-base_icon--image"
                aria-hidden="true"
                role="img"
                alt=""
                style="height: 24px; width: 24px;"
            ></span><a
            target="_blank"
            rel="noopener noreferrer"
            class="c-link c-message__reply_count"
            href=""
            @click.prevent
        >{{message.reply_count}} replies<span aria-label="(opens in new tab)"></span></a>
        <div class="c-message__reply_bar_description"><span class="c-message__reply_bar_last_reply">Last reply {{get_date_text()}}</span><span class="c-message__reply_bar_view_thread">View thread</span></div><i
            class="c-deprecated-icon c-message__reply_bar_arrow c-icon--chevron-right c-deprecated-icon--vertical-align-baseline"
            type="chevron_right"
            aria-hidden="true"
        ></i>
    </div>
</template>
<script>
export default {
    computed: {
        visible() {
            return !!this.message.reply_count
        },
    },
    data() {
        return {
            now: new Date()
        }
    },
    methods: {
        get_date_text() {
            const ts = parseFloat(this.message.latest_reply) * 1000
            let date = new Date(ts), date_text = null, now = this.now
            const seconds = (now.getTime() - date.getTime()) / 1000
                , minutes = Math.floor(seconds / 60)
                , hours = Math.floor(minutes / 60)
                , days = Math.floor(hours / 24)
            if (seconds < 60) {
                date_text = `${seconds} seconds ago`
            } else if (minutes < 60) {
                date_text = `${minutes} minutes ago`
            } else if (hours < 6) {
                date_text = `${hours} hours ago`
            } else if (hours < 24) {
                date_text = 'Today'
            } else if (hours < 48) {
                date_text = 'Yesterday'
            } else {
                date_text = `${days} days ago`
            }
            return date_text
        },
    },
    mounted() {
    },
    props: ['channel', 'message'],
    unmounted() {
    },
}
</script>
<style>
.c-message__reply_bar {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  font-size: 13px;
  height: 34px;
  margin: 4px 0 -2px -5px;
  max-width: 600px;
  overflow: hidden;
  padding: 4px; }
.c-message__reply_bar.c-message_kit__thread_replies {
  margin-bottom: 4px;
  margin-top: -4px; }
.c-message__reply_bar .c-message__reply_bar_avatar {
  cursor: pointer;
  height: 24px;
  width: 24px; }
.c-message__reply_bar .c-message__reply_bar_avatar.c-avatar {
  display: inline-block;
  flex-shrink: 0;
  margin-right: 4px;
  outline: none;
  position: relative; }
.c-message__reply_bar .c-message__reply_bar_avatar.c-avatar .c-base_icon {
  background-color: rgba(var(--sk_foreground_low,29,28,29),.13);
  border-radius: 4px;
  flex-shrink: 0;
  position: relative; }
.c-message__reply_bar .c-message__reply_bar_avatar.c-avatar .c-base_icon.c-base_icon--image {
  background-repeat: no-repeat;
  background-size: 100%;
  display: inline-block; }
.c-message__reply_bar a {
  color: rgba(var(--sk_primary_foreground,29,28,29),1);
  text-decoration: none; }
.c-message__reply_bar a.c-message__reply_count {
  margin-left: 3px;
  font-weight: 700;
  flex-shrink: 0; }
.c-message__reply_bar .c-message__reply_bar_description {
  color: rgba(var(--sk_highlight,18,100,163),1)
;
  flex: 1;
  margin-left: 8px;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap; }
.c-message__reply_bar .c-message__reply_bar_description .c-message__reply_bar_last_reply {
  opacity: 1;
  transition: opacity .2s; }
.c-message__reply_bar .c-message__reply_bar_description .c-message__reply_bar_view_thread {
  bottom: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  text-overflow: ellipsis;
  top: 0;
  transition: opacity .2s;
  white-space: nowrap; }
.c-message__reply_bar .c-message__reply_bar_arrow {
  margin-left: auto;
  color: transparent; }
.c-message__reply_bar .c-message__reply_bar_arrow:before {
  vertical-align: top; }
.c-message__reply_bar:hover {
  background-color: rgba(var(--sk_foreground_max_solid,97,96,97),1)
}
.c-message__reply_bar:hover .c-message__reply_bar_description .c-message__reply_bar_last_reply {
  opacity: 0; }
.c-message__reply_bar:hover .c-message__reply_bar_description .c-message__reply_bar_view_thread {
  opacity: 1; }
.c-message__reply_bar:hover .c-message__reply_bar_arrow {
  color: rgba(var(--sk_primary_background, 255, 255, 255), 1)
; }

</style>